<template>
    <div v-if="visible" class="video-container">
        <input v-if="!video && !processing" id="input-file-video" type="file" @change="addVideo" accept=".mp4, .webm, .mov" />
        <video v-if="video && video !== 'processing'" :src="videoSrc ? videoSrc : video" controls />
        <div v-if="video && video !== 'processing'" class="video-container-remove" @click="removeVideo">
            <i class="fa fa-times"></i>
        </div>
        <div v-if="!video || video === 'processing'" class="element-button-info">
            <div v-show="!processing && video !== 'processing'" class="element-button-info-text">
                <i class="fa fa-plus"></i>
                <span>{{ $parent.str['add_video'] }}</span>
            </div>
            <div v-if="processing || video === 'processing'" class="element-button-info-processing">
                {{ $parent.str['processing'] }}
            </div>
        </div>
    </div>
</template>
<style scoped>
.video-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.video-container video {
    width: 100%;
    max-height: 300px;
}

.video-container input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 7;
    opacity: 0;
}

.video-container button svg {
    margin-right: 10px;
}

.video-container img {
    max-width: 100%;
}

.video-container-remove {
    position: absolute;
    z-index: 7;
    right: 10px;
    top: 10px;
    font-size: 22px;
    cursor: pointer;
}

.element-button-info {
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    height: 100px;
    border: 1px solid #fff;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.element-button-info-text {
    display: flex;
    justify-content: center;
    align-items: center;
}

.element-button-info-text svg {
    margin-right: 7px;
}

.element-button-info-processing {
    text-align: center;
}
</style>
<script>
import StorageApi from '../services/StorageApi'
import Utils from '../services/Utils'

export default {
    name: 'video-element',
    props: ['callback', 'argument', 'video'],
    data() {
        return {
            visible: true,
            processing: null,
            videoSrc: null,
        }
    },
    methods: {
        addVideo: function (event) {
            const self = this

            if (!this.$parent.config.upload_video) {
                return this.$alert(this.$parent.str['no_data'], '', 'warning', Utils.getAlertOptions())
            }

            const file = event.srcElement.files[0]
            this.processing = true
            this.uploadVideo(file, function (result) {
                self.processing = false
                if (result) {
                    self.callback(result, self.argument)
                } else {
                    self.callback(null, self.argument)
                    self.$alert(self.$parent.str['upload_video_error'], '', 'warning', Utils.getAlertOptions())
                }
            })
        },
        uploadVideo: function (file, callback) {
            const self = this
            const reader = new FileReader()
            this.callback('processing', this.argument)
            reader.readAsDataURL(file)
            reader.onload = function () {
                StorageApi.sendFile(
                    {
                        file: {
                            name: self.$parent.config.upload_video.name + file.name,
                            type: 0,
                            file: reader.result,
                        },
                    },
                    function (response) {
                        if (response.success && response.data && response.data.id) {
                            self.videoSrc = reader.result
                            callback(response.data.id.toString())
                        } else {
                            callback(false)
                        }
                    },
                )
            }
            reader.onerror = function () {
                callback(false)
            }
        },
        removeVideo: function () {
            const self = this
            this.callback(null, this.argument)
            this.visible = false
            setTimeout(function () {
                self.visible = true
            })
        },
    },
}
</script>
